import type { DDAEntry } from "../../types";
import ListCell from "../ListCell";
import { RemoveIcon } from "../Icons";
import ButtonGroup from "../ButtonGroup";
import Button from "../Button";
import React, { Fragment } from "react";
import Avatar from "../Avatar";
import Badge from "../Badge";
import ErrorBlock from "../ErrorBlock";
import { DDAFeeAccountInformationSchema } from "../../validators/schemas/ddaFeeAccount";
import { ValidationError } from "yup";

type ResolvedDDAFormProps = {
  dda_entry: DDAEntry,
  onEditClick: (id: string) => void,
  onDeleteClick?: (id: string) => void
};

const hasError = (dda_entry: DDAEntry) => {
  try {
    DDAFeeAccountInformationSchema.validateSync(dda_entry, { abortEarly: false });
  } catch (exception) {
    if (ValidationError.isError(exception)) {
      return true;
    }
  }
  return false;
};

export const ResolvedDDAForm = (props: ResolvedDDAFormProps) => {

  const hasServerError = Boolean(props.dda_entry.serverSideValidationErrors);
  let Wrapper = Fragment;
  let wrapperProps;

  if (hasServerError) {
    Wrapper = Badge;
    wrapperProps = {
      label: "!"
    };
  }

  return (
    <React.Fragment>
      <ListCell
        leftAccessory={
          <Wrapper {...wrapperProps}>
            <Avatar />
          </Wrapper>
        }
        title={`DDA Signed by ${props.dda_entry.accountHolderName}${props.dda_entry.accountHolderTitle ? `, ${props.dda_entry.accountHolderTitle}` : ''}`}
        rightAccessory={
          <ButtonGroup>
            <Button
              intent="secondary"
              size="small"
              onClick={() => props.onEditClick(props.dda_entry.id)}>
              Edit
            </Button>
            <Button
              intent="danger"
              size="small"
              title="Remove"
              onClick={() => props.onDeleteClick && props.onDeleteClick(props.dda_entry.id)}>
              <RemoveIcon />
            </Button>
          </ButtonGroup>
        }
      />
      {hasError(
        props.dda_entry,
      ) && (
        <ErrorBlock message="There is an error with the fee account information, please update it" />
      )}
    </React.Fragment>
  );
};